<template>
  <div class="flex">
    <a :href="fbShare" target="_blank" rel="noopener" class="btn">Facebook</a>
    <a :href="twitterShare" target="_blank" rel="noopener" class="btn">Twitter</a>
    <a :href="emailShare" class="btn">E-mail</a>
    <button @click="cancel" class="btn"><close :stroke="true" width="18" height="18"/></button>
  </div>
</template>

<script>
  import Close from '@/components/icons/Close'

  export default {
    name: 'Sharing',
    props: {
      title: String
    },
    computed: {
      url () {
        return window.location.href
      },
      fbShare () {
        return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
      },
      twitterShare () {
        return `http://www.twitter.com/share?url=${this.url}`
      },
      emailShare () {
        return `mailto:?subject=${this.title}&body=${this.title}%0A${this.url}`
      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      }
    },
    components: { Close }
  }
</script>
